import { Dispatch, SetStateAction, useRef, useState } from "react";
import { Checkbox, Icon, Popup } from "semantic-ui-react";
import { ITableDto } from "../../../models/table";
import "../FiguresAndTables.css";
import html2canvas from "html2canvas";
import { TableComponent } from "./TableComponent";
import { PublishTableModal } from "./PublishTableModal";

interface IProps {
    table: ITableDto;
    setTableToEdit: Dispatch<SetStateAction<ITableDto | undefined>>;
    setTableToOpen: Dispatch<SetStateAction<ITableDto>>;
    setTableToDelete: Dispatch<SetStateAction<ITableDto>>;
    selectedForDelete: boolean;
    setSelectedForDelete: (id: string, selected: boolean) => void;
    tableData: string[][];
    refreshTables: () => void;
    handleClearFilter: () => void;
}

export const TableDisplay = ({
    table,
    setTableToEdit,
    setTableToOpen,
    setTableToDelete,
    selectedForDelete,
    setSelectedForDelete,
    tableData,
    refreshTables,
    handleClearFilter,
}: IProps) => {
    const captureRef = useRef<HTMLDivElement>(null);
    const [publishTableModalOpen, setPublishTableModalOpen] = useState(false);

    const handleTableDownload = async () => {
        if (!captureRef || !captureRef.current) {
            return;
        }
        html2canvas(captureRef.current).then(canvas => {
            const link = document.createElement("a");
            link.download = `table_${table.name}.png`;
            link.href = canvas.toDataURL("image/png");
            link.click();
        });
    };

    return (
        <>
            <div className="action-bar-container list-view" key={table.guid}>
                {table.final && (
                    <Checkbox
                        className="delete-select-checkbox"
                        checked={selectedForDelete}
                        onChange={(_e, data) =>
                            setSelectedForDelete(table.guid, data.checked as boolean)
                        }
                    />
                )}
                <div className="figure-table-row-container">
                    <div className="figure-table-row" onClick={() => setTableToOpen(table)}>
                        <Icon name="table" />
                        <p>{table.name}</p>
                    </div>
                </div>

                <div className="action-bar-container-options">
                    <Popup
                        content="Edit table"
                        trigger={
                            <Icon
                                id="button-edit"
                                name="edit"
                                bordered
                                onClick={() => setTableToEdit(table)}
                            />
                        }
                    />
                    {table.final && (
                        <>
                            <Popup
                                content="Download table"
                                trigger={
                                    <Icon
                                        id="button-download"
                                        name="download"
                                        bordered
                                        onClick={() => handleTableDownload()}
                                    />
                                }
                            />
                            <Popup
                                content="Unpublish table"
                                trigger={
                                    <Icon
                                        id="button-unpublish"
                                        name="hide"
                                        bordered
                                        onClick={() => setPublishTableModalOpen(true)}
                                    />
                                }
                            />
                        </>
                    )}
                    {!table.final && (
                        <Popup
                            content="Publish table"
                            trigger={
                                <Icon
                                    id="button-publish"
                                    name="unhide"
                                    bordered
                                    onClick={() => setPublishTableModalOpen(true)}
                                />
                            }
                        />
                    )}
                    <Popup
                        content="Delete table"
                        trigger={
                            <Icon
                                id="button-delete"
                                name="delete"
                                bordered
                                onClick={() => setTableToDelete(table)}
                            />
                        }
                    />
                </div>
            </div>
            <span className="table-download-container table-data-container" ref={captureRef}>
                <TableComponent tableData={tableData} />
            </span>
            <PublishTableModal
                publishTableModalOpen={publishTableModalOpen}
                closePublishTableModal={() => setPublishTableModalOpen(false)}
                tableToPublish={table}
                handleClearFilter={handleClearFilter}
                refreshTables={refreshTables}
            />
        </>
    );
};
